// This is just an object that holds state for the application.
// We could do this in a more involved way (redux, etc) in the future.
module.exports = {
  apiURL: '',
}



// WEBPACK FOOTER //
// ./src/state.js